import React, { Component } from "react";
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

import Button from "../../components/Button";


class VPractice3B extends Component {

constructor(props) {
    super(props);

this.handleClick = this.handleClick.bind(this)
	
}

handleClick(){this.props.practiceTaskUserId(["Practice03B", "/feedback"]);
	}

render() {
    return (
	<div> 
		
		<InstructionContainer>
			
		<P> Click the button to start practice task #3. 
		</P>

		
		</InstructionContainer>
		
		<StyledButton onClick={this.handleClick}>
			<RedirectLink to="/align">Practice #3</RedirectLink>
		</StyledButton>
		
	</div>
	);
	}
}
export default VPractice3B;



// justify-content: center;
// align-items: center;
// display: column;

// layout
const InstructionContainer = styled.div`
background: lightblue;
margin: 1em;
width: 90vw;


 ${props => props.primary && css `  //that's for displaying app component
    background: #e0e0e0;
	max-width: 60vw;
	margin: auto;
  `}

`;
 
const P = styled.p`
text-align: left;
font-size: large;

	${props => props.primary && css `  //that's for displaying app component
    font-size: small;
	`}

`;

const InstructionImage = styled.img`
overflow: scroll;
width: 90vw;
margin: 1em;

`;

const StyledButton = styled(Button)`
  width: 15%;
  float: left
  margin-left: 40%
  ${props => props.primary && css ` 
    background: orange;
	margin-left: 0%;
	
	`}
`;

const RedirectLink = styled(Link)`
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0);
  padding: 20px 10px;
  border-radius: 4px;
  text-decoration: none;
  color: inherit;
  transition: all 300ms;
  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;
